import React from 'react';
import ReactDOM from 'react-dom';
import Docs from './docs';

ReactDOM.render(
  <Docs />,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js